'use client';

import * as React from 'react';
export type ProfileContextValue = {
  isEditMode: boolean;
  setIsEditMode: React.Dispatch<React.SetStateAction<boolean>>;
};
export const ProfileContext = React.createContext<ProfileContextValue | null>(null);
export const ProfileProvider = React.memo(function ProfileProvider({
  children
}: React.PropsWithChildren) {
  const [isEditMode, setIsEditMode] = React.useState(false);
  const contextValue: ProfileContextValue = {
    isEditMode,
    setIsEditMode
  };
  return <ProfileContext.Provider value={contextValue}>{children}</ProfileContext.Provider>;
});